import React from 'react';
import ContentLoader from 'react-content-loader';

const ServiceListLoader = () => {
  const loaders = [];
  for (let i = 0; i < 10; i++) {
    loaders.push(i);
  }
  return (
    <div>
      {loaders.map((id) => {
        return (
          <ContentLoader
            className="mos-service-item"
            key={id}
            width={500}
            height={30}
            style={{
              height: '50px',
              padding: '0',
            }}
          >
            <rect x="0" y="0" rx="2" ry="2" width="500" height="30" />
          </ContentLoader>
        );
      })}
    </div>
  );
};

export default ServiceListLoader;
